import { decamelize } from "humps";
import has from "lodash/has";
import {
  FIELD_CUSTOM_FIELDS_KEY,
  FIELD_METADATA_KEY
} from "PFApp/constants/activity_form/activity_form_field_keys";
import { MultiActivityForm } from "PFApp/types/activity_form/activity_form_schema";

export const getFieldReferenceKey = (
  itemIdentifier: string,
  field: string,
  formValues: MultiActivityForm
) => {
  const formField = decamelize(field);

  const keyInCustomFields = `${itemIdentifier}.${FIELD_CUSTOM_FIELDS_KEY}.${formField}`;
  const keyInMetadataFields = `${itemIdentifier}.${FIELD_METADATA_KEY}.${formField}`;

  if (has(formValues, keyInCustomFields)) {
    return keyInCustomFields;
  }

  if (has(formValues, keyInMetadataFields)) {
    return keyInMetadataFields;
  }

  return `${itemIdentifier}.${formField}`;
};
